﻿import axios from "axios";
import { EPCSOLandingForm } from "./types/EPCSOLandingForm";
import { EPCSOLandingGarantieModel } from "./types/EPCSOLandingGarantieModel";
import { correctDates } from "../core/ajax/helper";

declare var _root_url: string;
function mapUrl(url: string) {
    return _root_url + url;
}

export abstract class LandingController {

  public static async GetLandingForm(name: string): Promise<EPCSOLandingForm> {
    const result = await axios.post(mapUrl("Landing/GetLandingForm"), {name});
    return correctDates(result.data);
  }

  public static async IsValidSeriennummer(seriennummer: string, sourcepage: string): Promise<string> {
    const result = await axios.post(mapUrl("Landing/IsValidSeriennummer"), {seriennummer, sourcepage});
    return correctDates(result.data);
  }

  public static async SendGarantieCustomerData(garantieData: EPCSOLandingGarantieModel): Promise<string> {
    const result = await axios.post(mapUrl("Landing/SendGarantieCustomerData"), {garantieData});
    return correctDates(result.data);
  }

}
